
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/culinary",
      function () {
        return require("private-next-pages/blogs/culinary/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/culinary"])
      });
    }
  